var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "30E724C3-9AD5-4D96-BE36-849D490D71CD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-793.000000, -1281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/icon/ic_Uncheck-Copy",
    transform: "translate(793.000000, 1281.887329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,2.4 L18,2.4 C19.9882251,2.4 21.6,4.0117749 21.6,6 L21.6,18 C21.6,19.9882251 19.9882251,21.6 18,21.6 L6,21.6 C4.0117749,21.6 2.4,19.9882251 2.4,18 L2.4,6 C2.4,4.0117749 4.0117749,2.4 6,2.4 Z",
    id: "Shape",
    fill: "#008556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8321387,11.1360828 C8.36048495,10.6704979 7.6007029,10.6754177 7.135118,11.1470715 C6.6695331,11.6187252 6.67445287,12.3785073 7.14610662,12.8440922 L10.195253,15.8540047 C10.6968832,16.3491803 11.5152435,16.3074124 11.9638523,15.7637379 L16.9147059,9.7637379 C17.3365067,9.25255236 17.2640461,8.4962175 16.7528606,8.07441671 C16.241675,7.65261592 15.4853402,7.72507657 15.0635394,8.2362621 L10.9476433,13.2243669 L8.8321387,11.1360828 Z",
    id: "Checklist",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox_checked.b426581276db21b0f4f5f83950d6d565.svg";
export { ForwardRef as ReactComponent };